module.exports = __webpack_public_path__ + "static/media/folderIcon.16bb7382.svg";